export default () => {
    const w = $(window);
    const viewportHeight = Math.max(document.documentElement.clientHeight
                                    || 0, window.innerHeight
                                    || 0);
    const backToTop = $('.icon-up-line');

    w.scroll(() => {
        if (w.scrollTop() > viewportHeight) {
            backToTop.fadeIn();
        } else {
            backToTop.fadeOut();
        }
    });

    // scroll body to 0px on click
    backToTop.on('click', () => {
        $('body,html').animate({
            scrollTop: 0,
        }, 800);
        return false;
    });
};
